import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=1648f27a&scoped=true"
import script from "./accountList.vue?vue&type=script&lang=js"
export * from "./accountList.vue?vue&type=script&lang=js"
import style0 from "./accountList.vue?vue&type=style&index=0&id=1648f27a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648f27a",
  null
  
)

export default component.exports